import { useState, FormEvent } from 'react';
import { useAuth } from '../AuthContext';
import { login } from '../api';

export default function LoginPage() {
  const { setAuth, refreshUser } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);

    const { data, error: err } = await login(email, password);
    setLoading(false);

    if (err) {
      setError(err);
      return;
    }

    if (data) {
      setAuth(data.token, data.user);
      await refreshUser();
    }
  }

  return (
    <div className="page">
      <div className="card" style={{ maxWidth: 400, margin: '80px auto' }}>
        <h1>AK Pizza Bot</h1>
        <p style={{ color: '#666', marginBottom: 24 }}>Sign in to manage your pizza drops</p>

        <form onSubmit={handleSubmit}>
          <div className="field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="error">{error}</div>}

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p style={{ marginTop: 16, textAlign: 'center' }}>
          Have an invite code? <a href="/register">Register</a>
        </p>
      </div>
    </div>
  );
}
